import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ButtonCardUI from './ButtonCardUI';
import { routingActionCreator } from './actions/routingActionCreators';

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        onButtonClick: (route) => dispatch(routingActionCreator(route))
    };
};

const ButtonCardContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ButtonCardUI);

export default ButtonCardContainer;
